import React from 'react';
import { useDispatch } from 'react-redux';
import Icon, { COLORS, ICONS } from '../../general-components/icon';
import { setSolutionCenterContentState } from '../../../stores/actions/user-interface';
import {
	RECENT_ACTIVITY_ITEMS,
	RecentActivityTypes,
	SolutionCenterContentTypes,
	ZendeskCategory,
} from '../../../types/solution-center';

interface HomeViewProps {
	categories: ZendeskCategory[];
	handleSelectCategory: (categoryId: number) => void;
}

export default function HomeView(props: HomeViewProps) {
	const dispatch = useDispatch();

	const {
		categories,
		handleSelectCategory,
	} = props;

	const handleItemOnClick = (id: number, type: RecentActivityTypes) => {
		if (type === RecentActivityTypes.Article || type === RecentActivityTypes.Post) {
			dispatch(setSolutionCenterContentState({
				id,
				type: type === RecentActivityTypes.Article
					? SolutionCenterContentTypes.Article
					: SolutionCenterContentTypes.Post,
			}));
		} else if (type === RecentActivityTypes.Category) {
			handleSelectCategory(id);
		}
	};

	return (
		<>
			<div className="sc-home-section">
				<span className="sc-home-section-header">Products</span>
				<ul className="sc-products-list">
					{/* Show the first 5 categories */}
					{categories.filter((c) => c.position < 5).map((category) => (
						<li key={`category-${category.id}`} className="sc-products-list-item">
							<span className="sc-products-list-item-text" onClick={() => handleSelectCategory(category.id)}>
								{category.name}
							</span>
						</li>
					))}
				</ul>
			</div>
			<div className="sc-home-section">
				<span className="sc-home-section-header">Recent Activity</span>
				<ul className="sc-list">
					{RECENT_ACTIVITY_ITEMS.map((item) => (
						<li key={`recent-activity-${item.id}`} className="sc-search-item recent-activity">
							<div>
								<span className="sc-recent-activity-text" onClick={() => handleItemOnClick(item.id, item.type)}>
									{item.title}&nbsp;
								</span>
								<a
									className="sc-recent-activity-icon-link"
									href={item.url}
									target="_blank"
									rel="noopener noreferrer"
								>
									<Icon name={ICONS.EXPAND} size={16} color={COLORS.PALE_GREEN} />
								</a>
							</div>
							<p className="sc-search-item-snippet">{item.snippet}</p>
						</li>
					))}
				</ul>
			</div>
			<div className="sc-shadow" />
		</>
	);
}
